export const translations = {
  fr: {
    // Header & Navigation
    'nav.home': 'Accueil',
    'nav.about': 'À propos',
    'nav.expertises': 'Expertises',
    'nav.caseStudies': 'Études de cas',
    'nav.institutional': 'Conseil Institutionnel',
    'nav.team': 'Équipe',
    'nav.studio': 'Studio Digital',
    'nav.contact': 'Contact',
    'nav.contactUs': 'Nous contacter',
    'nav.langToggle': 'EN',

    // Home Page
    'home.hero.title': 'Votre partenaire pour la transformation digitale et la gouvernance souveraine en Afrique',
    'home.hero.subtitle': 'Conseil stratégique pour les institutions publiques et solutions digitales pour les entreprises africaines',
    'home.hero.cta1': 'Discuter de votre projet institutionnel',
    'home.hero.cta2': 'Démarrer votre projet digital',
    
    'home.offers.title': 'Deux offres claires',
    'home.offers.institutional.title': 'Conseil Institutionnel',
    'home.offers.institutional.target': 'Pour les ministères, agences nationales, bailleurs internationaux',
    'home.offers.institutional.desc': 'Digitalisation des registres nationaux, e-gouvernement, gestion de projets EPC+F, cloud souverain, gouvernance des données',
    'home.offers.institutional.cta': 'Discuter de votre projet institutionnel',
    'home.offers.studio.title': 'Studio Digital',
    'home.offers.studio.target': 'Pour les PME, startups et entreprises africaines',
    'home.offers.studio.desc': 'Applications mobiles (Flutter), plateformes web (Next.js), tableaux de bord, solutions offline-first pour environnements à faible connectivité',
    'home.offers.studio.cta': 'Démarrer votre projet digital',

    'home.why.title': 'Pourquoi Maalow',
    'home.why.offline.title': 'Expertise Offline-First',
    'home.why.offline.desc': 'Solutions conçues pour fonctionner dans des environnements à faible connectivité',
    'home.why.sovereign.title': 'Infrastructure Souveraine Africaine',
    'home.why.sovereign.desc': 'Hébergement et gouvernance des données respectant la souveraineté africaine',
    'home.why.coverage.title': '8 Pays Couverts',
    'home.why.coverage.desc': 'Présence active au Sénégal, Mali, Burkina Faso, Niger, Côte d\'Ivoire, Guinée, Mauritanie, France',
    'home.why.experience.title': 'Expertise Éprouvée',
    'home.why.experience.desc': '15-20+ années d\'expérience en conseil stratégique et transformation digitale',

    'home.prototypes.title': 'Nos Prototypes R&D',
    'home.prototypes.subtitle': 'Projets internes développés pour démontrer nos capacités techniques',
    'home.prototypes.disclaimer': 'Ces projets sont des prototypes R&D internes, non des projets clients livrés',
    'home.prototypes.view': 'Voir tous les prototypes',

    'home.team.title': 'Dirigé par des experts africains',
    'home.team.subtitle': 'Une équipe de consultants seniors avec une expertise approfondie en gouvernance, transformation digitale et gestion de projets complexes',
    'home.team.cta': 'Rencontrer l\'équipe',

    'home.cta.title': 'Prêt à transformer votre institution ou votre entreprise ?',
    'home.cta.subtitle': 'Discutons de votre projet et de la manière dont Maalow peut vous accompagner',
    'home.cta.button': 'Planifier une consultation',

    // About Page
    'about.hero.title': 'À propos de Maalow',
    'about.hero.subtitle': 'Conseil stratégique et transformation digitale pour l\'Afrique',
    
    'about.mission.title': 'Notre Mission',
    'about.mission.text': 'Maalow Consulting Services accompagne les institutions publiques africaines et les entreprises dans leur transformation digitale et leur modernisation organisationnelle. Nous combinons expertise en gouvernance, maîtrise technologique et connaissance approfondie du contexte africain.',
    
    'about.values.title': 'Nos Valeurs',
    'about.values.excellence.title': 'Excellence',
    'about.values.excellence.desc': 'Standards internationaux adaptés au contexte africain',
    'about.values.integrity.title': 'Intégrité',
    'about.values.integrity.desc': 'Transparence et éthique dans toutes nos missions',
    'about.values.innovation.title': 'Innovation',
    'about.values.innovation.desc': 'Solutions modernes et pragmatiques',
    'about.values.impact.title': 'Impact Durable',
    'about.values.impact.desc': 'Transfert de compétences et autonomisation',

    'about.vision.title': 'Notre Vision',
    'about.vision.quote': 'Construire une Afrique digitale souveraine, où les institutions publiques et les entreprises maîtrisent leurs données et leurs systèmes d\'information.',
    'about.vision.author': 'Papa Mamadou Diop, Directeur Général',

    'about.presence.title': 'Notre Présence',
    'about.presence.headquarters': 'Siège Social',
    'about.presence.hq.location': 'Dakar, Sénégal',
    'about.presence.hq.address': 'N/75 Hann Maristes 2',
    'about.presence.coverage': 'Couverture Régionale',
    'about.presence.countries': 'Sénégal, Mali, Burkina Faso, Niger, Côte d\'Ivoire, Guinée, Mauritanie, France',

    'about.legal.title': 'Informations Légales',
    'about.legal.ninea': 'NINEA',
    'about.legal.rccm': 'RCCM',

    // Contact Page
    'contact.hero.title': 'Construisons Ensemble',
    'contact.hero.subtitle': 'Que vous soyez une institution publique ou une entreprise, nous sommes là pour vous accompagner',

    'contact.tab.institutional': 'Projet Institutionnel',
    'contact.tab.studio': 'Projet Studio Digital',

    'contact.form.name': 'Nom complet',
    'contact.form.email': 'Email',
    'contact.form.phone': 'Téléphone',
    'contact.form.institution': 'Institution / Organisation',
    'contact.form.company': 'Entreprise / Startup',
    'contact.form.country': 'Pays',
    'contact.form.projectType': 'Type de projet',
    'contact.form.projectType.select': 'Sélectionner un type de projet',
    'contact.form.projectType.institutional': 'Projet Institutionnel',
    'contact.form.projectType.studio': 'Studio Digital',
    'contact.form.projectType.other': 'Autre',
    'contact.form.projectType.governance': 'Gouvernance & planification stratégique',
    'contact.form.projectType.egovernment': 'E-gouvernement & registres nationaux',
    'contact.form.projectType.epcf': 'Gestion de projets EPC+F',
    'contact.form.projectType.cloud': 'Cloud souverain & cybersécurité',
    'contact.form.projectType.data': 'Gouvernance des données',
    'contact.form.projectType.registry': 'Digitalisation de registres',
    'contact.form.projectType.mobile': 'Application mobile',
    'contact.form.projectType.web': 'Plateforme web',
    'contact.form.projectType.dashboard': 'Tableau de bord',
    'contact.form.projectType.offline': 'Solution offline-first',
    'contact.form.description': 'Description du projet',
    'contact.form.organization': 'Organisation / Entreprise',
    'contact.form.message': 'Message',
    'contact.form.send': 'Envoyer le message',
    'contact.form.characters': 'caractères',
    'contact.form.budget': 'Budget estimé (optionnel)',
    'contact.form.budget.select': 'Sélectionner une fourchette',
    'contact.form.budget.small': 'Moins de 50 000 €',
    'contact.form.budget.medium': '50 000 € - 200 000 €',
    'contact.form.budget.large': '200 000 € - 1 000 000 €',
    'contact.form.budget.xlarge': 'Plus de 1 000 000 €',
    'contact.form.timeline': 'Délai souhaité',
    'contact.form.timeline.urgent': 'Urgent (moins de 3 mois)',
    'contact.form.timeline.standard': 'Standard (3-6 mois)',
    'contact.form.timeline.flexible': 'Flexible (6+ mois)',
    'contact.form.submit': 'Envoyer la demande',
    'contact.form.success': 'Merci ! Nous vous contacterons sous 24h.',
    'contact.form.error': 'Erreur lors de l\'envoi. Veuillez réessayer.',
    'contact.form.charLimit': 'Maximum 500 caractères',

    'contact.info.title': 'Informations de Contact',
    'contact.info.email': 'Email',
    'contact.info.address': 'Adresse',
    'contact.info.hours': 'Horaires',
    'contact.info.hours.value': 'Lun-Ven 9h-18h GMT',

    'contact.schedule.title': 'Planifier un Appel',
    'contact.schedule.text': 'Besoin d\'une consultation directe avec notre Directeur Général ?',
    'contact.schedule.button': 'Parler avec Papa Mamadou Diop',

    'contact.map.title': 'Notre Bureau à Dakar',

    // Expertises Page
    'expertises.hero.title': 'Nos Expertises',
    'expertises.hero.subtitle': 'Conseil stratégique et solutions digitales pour l\'Afrique',

    'expertises.institutional.title': 'Conseil Institutionnel',
    'expertises.institutional.governance.title': 'Gouvernance & Planification Stratégique',
    'expertises.institutional.governance.items': 'Plans Stratégiques de Développement (PSD/PSDI), Audits institutionnels, Réformes organisationnelles, Gestion de la performance',
    'expertises.institutional.digital.title': 'Transformation Digitale',
    'expertises.institutional.digital.items': 'E-gouvernement, Systèmes d\'information intégrés (SIID/ERP), Digitalisation de registres nationaux, Interopérabilité des systèmes',
    'expertises.institutional.data.title': 'Gouvernance des Données',
    'expertises.institutional.data.items': 'Souveraineté des données, Cybersécurité, Cloud souverain, Protection des données personnelles',
    'expertises.institutional.projects.title': 'Gestion de Projets Complexes',
    'expertises.institutional.projects.items': 'EPC+F (Engineering, Procurement, Construction + Financing), BOT (Build, Operate, Transfer), Gestion de programmes multi-bailleurs',

    'expertises.studio.title': 'Studio Digital',
    'expertises.studio.mobile.title': 'Applications Mobiles',
    'expertises.studio.mobile.items': 'Flutter (iOS & Android), Solutions offline-first, Synchronisation intelligente, UX adaptée aux marchés africains',
    'expertises.studio.web.title': 'Plateformes Web',
    'expertises.studio.web.items': 'Next.js / React, Architectures évolutives, Interfaces administratives, Portails métiers',
    'expertises.studio.data.title': 'Tableaux de Bord & Analytics',
    'expertises.studio.data.items': 'Visualisation de données, KPI & reporting, Business Intelligence, Dashboards temps réel',

    'expertises.sectors.title': 'Secteurs d\'Intervention',
    'expertises.sectors.public': 'Administration Publique',
    'expertises.sectors.transport': 'Transport & Logistique',
    'expertises.sectors.health': 'Santé',
    'expertises.sectors.education': 'Éducation',
    'expertises.sectors.finance': 'Finance & Banque',
    'expertises.sectors.agriculture': 'Agriculture',

    'expertises.methodology.title': 'Notre Méthodologie',
    'expertises.methodology.step1.title': 'Diagnostic',
    'expertises.methodology.step1.desc': 'Analyse approfondie de vos besoins et contraintes',
    'expertises.methodology.step2.title': 'Conception',
    'expertises.methodology.step2.desc': 'Co-construction de solutions adaptées',
    'expertises.methodology.step3.title': 'Mise en œuvre',
    'expertises.methodology.step3.desc': 'Déploiement avec accompagnement terrain',
    'expertises.methodology.step4.title': 'Transfert',
    'expertises.methodology.step4.desc': 'Formation et autonomisation de vos équipes',

    'expertises.cta.title': 'Discutons de votre projet',
    'expertises.cta.button': 'Nous contacter',

    // Case Studies Page
    'caseStudies.hero.title': 'Nos Prototypes R&D',
    'caseStudies.hero.subtitle': 'Projets internes développés pour démontrer nos capacités techniques',

    'caseStudies.disclaimer': 'Ces projets sont des prototypes R&D internes, non des projets clients livrés',

    'caseStudies.filter.all': 'Tous les prototypes',
    'caseStudies.filter.institutional': 'Institutionnel',
    'caseStudies.filter.studio': 'Studio Digital',

    'caseStudies.transport.title': 'Registre National des Transports',
    'caseStudies.transport.category': 'Prototype Institutionnel',
    'caseStudies.transport.desc': 'Système de gestion des professionnels du transport avec cartes sécurisées, dashboard administratif et architecture offline-first',
    'caseStudies.transport.highlight1': 'Architecture offline-first',
    'caseStudies.transport.highlight2': 'Cartes professionnelles sécurisées',
    'caseStudies.transport.highlight3': 'Dashboard de gestion',

    'caseStudies.health.title': 'Plateforme E-Santé',
    'caseStudies.health.category': 'Prototype Institutionnel',
    'caseStudies.health.desc': 'Système de gestion des dossiers médicaux électroniques avec interopérabilité entre établissements de santé',
    'caseStudies.health.highlight1': 'Dossiers médicaux électroniques',
    'caseStudies.health.highlight2': 'Interopérabilité',
    'caseStudies.health.highlight3': 'Conformité RGPD',

    'caseStudies.agriculture.title': 'App Mobile Agricole',
    'caseStudies.agriculture.category': 'Prototype Studio Digital',
    'caseStudies.agriculture.desc': 'Application mobile Flutter pour le suivi des cultures et la gestion des exploitations agricoles, fonctionnant hors ligne',
    'caseStudies.agriculture.highlight1': 'Flutter (iOS & Android)',
    'caseStudies.agriculture.highlight2': 'Mode offline complet',
    'caseStudies.agriculture.highlight3': 'Géolocalisation des parcelles',

    'caseStudies.logistics.title': 'Plateforme Logistique',
    'caseStudies.logistics.category': 'Prototype Studio Digital',
    'caseStudies.logistics.desc': 'Plateforme web de gestion de flotte et suivi des livraisons en temps réel',
    'caseStudies.logistics.highlight1': 'Suivi temps réel',
    'caseStudies.logistics.highlight2': 'Gestion de flotte',
    'caseStudies.logistics.highlight3': 'Analytics avancés',

    'caseStudies.cta.title': 'Intéressé par nos capacités techniques ?',
    'caseStudies.cta.subtitle': 'Discutons de votre projet institutionnel ou digital',
    'caseStudies.cta.button': 'Démarrer une conversation',

    // Studio Digital Page
    'studio.hero.title': 'Studio Digital',
    'studio.hero.tagline': 'Construire pour l\'Afrique. Construit pour durer.',
    'studio.hero.subtitle': 'Solutions digitales modernes pour les entreprises africaines : applications mobiles, plateformes web, tableaux de bord',
    'studio.hero.cta': 'Démarrer votre projet',

    'studio.services.title': 'Nos Services',
    'studio.services.mobile.title': 'Applications Mobiles',
    'studio.services.mobile.desc': 'Apps natives iOS & Android avec Flutter, conçues pour fonctionner hors ligne',
    'studio.services.web.title': 'Plateformes Web',
    'studio.services.web.desc': 'Sites web et applications web modernes avec Next.js et React',
    'studio.services.dashboard.title': 'Tableaux de Bord',
    'studio.services.dashboard.desc': 'Interfaces de gestion et visualisation de données en temps réel',
    'studio.services.api.title': 'APIs & Backend',
    'studio.services.api.desc': 'Architectures backend robustes et APIs RESTful/GraphQL',

    'studio.process.title': 'Notre Processus',
    'studio.process.step1.title': 'Découverte',
    'studio.process.step1.desc': 'Comprendre vos besoins et objectifs business',
    'studio.process.step2.title': 'Design',
    'studio.process.step2.desc': 'Prototypes et maquettes UX/UI',
    'studio.process.step3.title': 'Développement',
    'studio.process.step3.desc': 'Code de qualité, tests, itérations',
    'studio.process.step4.title': 'Déploiement',
    'studio.process.step4.desc': 'Mise en production et formation',
    'studio.process.step5.title': 'Support',
    'studio.process.step5.desc': 'Maintenance et évolutions',

    'studio.offline.title': 'Expertise Offline-First',
    'studio.offline.subtitle': 'Nous comprenons les défis de connectivité en Afrique',
    'studio.offline.feature1.title': 'Synchronisation Intelligente',
    'studio.offline.feature1.desc': 'Vos données se synchronisent automatiquement quand la connexion revient',
    'studio.offline.feature2.title': 'Stockage Local',
    'studio.offline.feature2.desc': 'Toutes les fonctionnalités essentielles disponibles hors ligne',
    'studio.offline.feature3.title': 'Optimisation Réseau',
    'studio.offline.feature3.desc': 'Consommation minimale de données, adapté aux réseaux 2G/3G',

    'studio.tech.title': 'Technologies',
    'studio.tech.subtitle': 'Stack moderne et éprouvé',

    'studio.cta.title': 'Prêt à lancer votre projet digital ?',
    'studio.cta.subtitle': 'Discutons de votre idée et transformons-la en réalité',
    'studio.cta.button': 'Démarrer maintenant',

    // Team Page
    'team.hero.title': 'Notre Équipe',
    'team.hero.subtitle': 'Des experts africains au service de la transformation digitale',

    'team.leadership.title': 'Direction',
    'team.leadership.ceo.name': 'Papa Mamadou Diop',
    'team.leadership.ceo.role': 'Directeur Général',
    'team.leadership.ceo.bio': '20+ années d\'expérience en conseil stratégique et gestion de projets complexes. Expert en gouvernance publique et transformation digitale en Afrique de l\'Ouest.',

    'team.values.title': 'Ce qui nous unit',
    'team.values.expertise.title': 'Expertise Africaine',
    'team.values.expertise.desc': 'Connaissance approfondie des contextes institutionnels et business africains',
    'team.values.commitment.title': 'Engagement',
    'team.values.commitment.desc': 'Accompagnement de bout en bout avec transfert de compétences',
    'team.values.excellence.title': 'Excellence',
    'team.values.excellence.desc': 'Standards internationaux adaptés aux réalités locales',

    'team.cta.title': 'Travaillons ensemble',
    'team.cta.button': 'Nous contacter',

    // Footer
    'footer.tagline': 'Votre partenaire pour la transformation digitale et la gouvernance souveraine en Afrique',
    'footer.company.title': 'Entreprise',
    'footer.company.about': 'À propos',
    'footer.company.team': 'Équipe',
    'footer.company.contact': 'Contact',
    'footer.services.title': 'Services',
    'footer.services.institutional': 'Conseil Institutionnel',
    'footer.services.studio': 'Studio Digital',
    'footer.services.expertises': 'Expertises',
    'footer.services.cases': 'Études de cas',
    'footer.contact.title': 'Contact',
    'footer.legal.title': 'Légal',
    'footer.copyright': '© 2025 Maalow Consulting Services. Tous droits réservés.',

    // Common
    'common.learnMore': 'En savoir plus',
    'common.viewAll': 'Voir tout',
    'common.backHome': 'Retour à l\'accueil',
  },
  en: {
    // Header & Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.expertises': 'Expertise',
    'nav.caseStudies': 'Case Studies',
    'nav.institutional': 'Institutional Consulting',
    'nav.team': 'Team',
    'nav.studio': 'Digital Studio',
    'nav.contact': 'Contact',
    'nav.contactUs': 'Contact Us',
    'nav.langToggle': 'FR',

    // Home Page
    'home.hero.title': 'Your partner for digital transformation and sovereign governance in Africa',
    'home.hero.subtitle': 'Strategic consulting for public institutions and digital solutions for African businesses',
    'home.hero.cta1': 'Discuss your institutional project',
    'home.hero.cta2': 'Start your digital project',
    
    'home.offers.title': 'Two Clear Offers',
    'home.offers.institutional.title': 'Institutional Consulting',
    'home.offers.institutional.target': 'For ministries, national agencies, international donors',
    'home.offers.institutional.desc': 'National registries digitization, e-government, EPC+F project management, sovereign cloud, data governance',
    'home.offers.institutional.cta': 'Discuss your institutional project',
    'home.offers.studio.title': 'Digital Studio',
    'home.offers.studio.target': 'For SMEs, startups, and African businesses',
    'home.offers.studio.desc': 'Mobile apps (Flutter), web platforms (Next.js), dashboards, offline-first solutions for low-connectivity environments',
    'home.offers.studio.cta': 'Start your digital project',

    'home.why.title': 'Why Maalow',
    'home.why.offline.title': 'Offline-First Expertise',
    'home.why.offline.desc': 'Solutions designed to work in low-connectivity environments',
    'home.why.sovereign.title': 'African Sovereign Infrastructure',
    'home.why.sovereign.desc': 'Data hosting and governance respecting African sovereignty',
    'home.why.coverage.title': '8 Countries Covered',
    'home.why.coverage.desc': 'Active presence in Senegal, Mali, Burkina Faso, Niger, Côte d\'Ivoire, Guinea, Mauritania, France',
    'home.why.experience.title': 'Proven Expertise',
    'home.why.experience.desc': '15-20+ years of experience in strategic consulting and digital transformation',

    'home.prototypes.title': 'Our R&D Prototypes',
    'home.prototypes.subtitle': 'Internal projects developed to demonstrate our technical capabilities',
    'home.prototypes.disclaimer': 'These projects are internal R&D prototypes, not delivered client projects',
    'home.prototypes.view': 'View all prototypes',

    'home.team.title': 'Led by African experts',
    'home.team.subtitle': 'A team of senior consultants with deep expertise in governance, digital transformation, and complex project management',
    'home.team.cta': 'Meet the team',

    'home.cta.title': 'Ready to transform your institution or business?',
    'home.cta.subtitle': 'Let\'s discuss your project and how Maalow can support you',
    'home.cta.button': 'Schedule a consultation',

    // About Page
    'about.hero.title': 'About Maalow',
    'about.hero.subtitle': 'Strategic consulting and digital transformation for Africa',
    
    'about.mission.title': 'Our Mission',
    'about.mission.text': 'Maalow Consulting Services supports African public institutions and businesses in their digital transformation and organizational modernization. We combine governance expertise, technological mastery, and deep knowledge of the African context.',
    
    'about.values.title': 'Our Values',
    'about.values.excellence.title': 'Excellence',
    'about.values.excellence.desc': 'International standards adapted to the African context',
    'about.values.integrity.title': 'Integrity',
    'about.values.integrity.desc': 'Transparency and ethics in all our missions',
    'about.values.innovation.title': 'Innovation',
    'about.values.innovation.desc': 'Modern and pragmatic solutions',
    'about.values.impact.title': 'Sustainable Impact',
    'about.values.impact.desc': 'Skills transfer and empowerment',

    'about.vision.title': 'Our Vision',
    'about.vision.quote': 'Building a sovereign digital Africa, where public institutions and businesses control their data and information systems.',
    'about.vision.author': 'Papa Mamadou Diop, Managing Director',

    'about.presence.title': 'Our Presence',
    'about.presence.headquarters': 'Headquarters',
    'about.presence.hq.location': 'Dakar, Senegal',
    'about.presence.hq.address': 'N/75 Hann Maristes 2',
    'about.presence.coverage': 'Regional Coverage',
    'about.presence.countries': 'Senegal, Mali, Burkina Faso, Niger, Côte d\'Ivoire, Guinea, Mauritania, France',

    'about.legal.title': 'Legal Information',
    'about.legal.ninea': 'NINEA',
    'about.legal.rccm': 'RCCM',

    // Contact Page
    'contact.hero.title': 'Let\'s Build Together',
    'contact.hero.subtitle': 'Whether you\'re a public institution or a business, we\'re here to support you',

    'contact.tab.institutional': 'Institutional Project',
    'contact.tab.studio': 'Digital Studio Project',

    'contact.form.name': 'Full Name',
    'contact.form.email': 'Email',
    'contact.form.phone': 'Phone',
    'contact.form.institution': 'Institution / Organization',
    'contact.form.company': 'Company / Startup',
    'contact.form.country': 'Country',
    'contact.form.projectType': 'Project Type',
    'contact.form.projectType.select': 'Select a project type',
    'contact.form.projectType.institutional': 'Institutional Project',
    'contact.form.projectType.studio': 'Digital Studio Project',
    'contact.form.projectType.other': 'Other',
    'contact.form.projectType.governance': 'Governance & strategic planning',
    'contact.form.projectType.egovernment': 'E-government & national registries',
    'contact.form.projectType.epcf': 'EPC+F project management',
    'contact.form.projectType.cloud': 'Sovereign cloud & cybersecurity',
    'contact.form.projectType.data': 'Data governance',
    'contact.form.projectType.registry': 'Registry digitization',
    'contact.form.projectType.mobile': 'Mobile app',
    'contact.form.projectType.web': 'Web platform',
    'contact.form.projectType.dashboard': 'Dashboard',
    'contact.form.projectType.offline': 'Offline-first solution',
    'contact.form.description': 'Project Description',
    'contact.form.organization': 'Organization / Company',
    'contact.form.message': 'Message',
    'contact.form.send': 'Send Message',
    'contact.form.characters': 'characters',
    'contact.form.budget': 'Estimated Budget (optional)',
    'contact.form.budget.select': 'Select a range',
    'contact.form.budget.small': 'Less than €50,000',
    'contact.form.budget.medium': '€50,000 - €200,000',
    'contact.form.budget.large': '€200,000 - €1,000,000',
    'contact.form.budget.xlarge': 'More than €1,000,000',
    'contact.form.timeline': 'Desired Timeline',
    'contact.form.timeline.urgent': 'Urgent (less than 3 months)',
    'contact.form.timeline.standard': 'Standard (3-6 months)',
    'contact.form.timeline.flexible': 'Flexible (6+ months)',
    'contact.form.submit': 'Submit Request',
    'contact.form.success': 'Thank you! We\'ll contact you within 24h.',
    'contact.form.error': 'Error sending. Please try again.',
    'contact.form.charLimit': 'Maximum 500 characters',

    'contact.info.title': 'Contact Information',
    'contact.info.email': 'Email',
    'contact.info.address': 'Address',
    'contact.info.hours': 'Business Hours',
    'contact.info.hours.value': 'Mon-Fri 9AM-6PM GMT',

    'contact.schedule.title': 'Schedule a Call',
    'contact.schedule.text': 'Need a direct consultation with our Managing Director?',
    'contact.schedule.button': 'Talk with Papa Mamadou Diop',

    'contact.map.title': 'Our Office in Dakar',

    // Expertises Page
    'expertises.hero.title': 'Our Expertise',
    'expertises.hero.subtitle': 'Strategic consulting and digital solutions for Africa',

    'expertises.institutional.title': 'Institutional Consulting',
    'expertises.institutional.governance.title': 'Governance & Strategic Planning',
    'expertises.institutional.governance.items': 'Strategic Development Plans (PSD/PSDI), Institutional audits, Organizational reforms, Performance management',
    'expertises.institutional.digital.title': 'Digital Transformation',
    'expertises.institutional.digital.items': 'E-government, Integrated information systems (SIID/ERP), National registries digitization, Systems interoperability',
    'expertises.institutional.data.title': 'Data Governance',
    'expertises.institutional.data.items': 'Data sovereignty, Cybersecurity, Sovereign cloud, Personal data protection',
    'expertises.institutional.projects.title': 'Complex Project Management',
    'expertises.institutional.projects.items': 'EPC+F (Engineering, Procurement, Construction + Financing), BOT (Build, Operate, Transfer), Multi-donor program management',

    'expertises.studio.title': 'Digital Studio',
    'expertises.studio.mobile.title': 'Mobile Applications',
    'expertises.studio.mobile.items': 'Flutter (iOS & Android), Offline-first solutions, Smart synchronization, UX adapted to African markets',
    'expertises.studio.web.title': 'Web Platforms',
    'expertises.studio.web.items': 'Next.js / React, Scalable architectures, Admin interfaces, Business portals',
    'expertises.studio.data.title': 'Dashboards & Analytics',
    'expertises.studio.data.items': 'Data visualization, KPI & reporting, Business Intelligence, Real-time dashboards',

    'expertises.sectors.title': 'Sectors',
    'expertises.sectors.public': 'Public Administration',
    'expertises.sectors.transport': 'Transport & Logistics',
    'expertises.sectors.health': 'Healthcare',
    'expertises.sectors.education': 'Education',
    'expertises.sectors.finance': 'Finance & Banking',
    'expertises.sectors.agriculture': 'Agriculture',

    'expertises.methodology.title': 'Our Methodology',
    'expertises.methodology.step1.title': 'Diagnosis',
    'expertises.methodology.step1.desc': 'In-depth analysis of your needs and constraints',
    'expertises.methodology.step2.title': 'Design',
    'expertises.methodology.step2.desc': 'Co-construction of adapted solutions',
    'expertises.methodology.step3.title': 'Implementation',
    'expertises.methodology.step3.desc': 'Deployment with field support',
    'expertises.methodology.step4.title': 'Transfer',
    'expertises.methodology.step4.desc': 'Training and empowerment of your teams',

    'expertises.cta.title': 'Let\'s discuss your project',
    'expertises.cta.button': 'Contact us',

    // Case Studies Page
    'caseStudies.hero.title': 'Our R&D Prototypes',
    'caseStudies.hero.subtitle': 'Internal projects developed to demonstrate our technical capabilities',

    'caseStudies.disclaimer': 'These projects are internal R&D prototypes, not delivered client projects',

    'caseStudies.filter.all': 'All prototypes',
    'caseStudies.filter.institutional': 'Institutional',
    'caseStudies.filter.studio': 'Digital Studio',

    'caseStudies.transport.title': 'National Transport Registry',
    'caseStudies.transport.category': 'Institutional Prototype',
    'caseStudies.transport.desc': 'Transport professionals management system with secure cards, admin dashboard, and offline-first architecture',
    'caseStudies.transport.highlight1': 'Offline-first architecture',
    'caseStudies.transport.highlight2': 'Secure professional cards',
    'caseStudies.transport.highlight3': 'Management dashboard',

    'caseStudies.health.title': 'E-Health Platform',
    'caseStudies.health.category': 'Institutional Prototype',
    'caseStudies.health.desc': 'Electronic medical records management system with interoperability between healthcare facilities',
    'caseStudies.health.highlight1': 'Electronic medical records',
    'caseStudies.health.highlight2': 'Interoperability',
    'caseStudies.health.highlight3': 'GDPR compliant',

    'caseStudies.agriculture.title': 'Agricultural Mobile App',
    'caseStudies.agriculture.category': 'Digital Studio Prototype',
    'caseStudies.agriculture.desc': 'Flutter mobile app for crop monitoring and farm management, working offline',
    'caseStudies.agriculture.highlight1': 'Flutter (iOS & Android)',
    'caseStudies.agriculture.highlight2': 'Full offline mode',
    'caseStudies.agriculture.highlight3': 'Plot geolocation',

    'caseStudies.logistics.title': 'Logistics Platform',
    'caseStudies.logistics.category': 'Digital Studio Prototype',
    'caseStudies.logistics.desc': 'Web platform for fleet management and real-time delivery tracking',
    'caseStudies.logistics.highlight1': 'Real-time tracking',
    'caseStudies.logistics.highlight2': 'Fleet management',
    'caseStudies.logistics.highlight3': 'Advanced analytics',

    'caseStudies.cta.title': 'Interested in our technical capabilities?',
    'caseStudies.cta.subtitle': 'Let\'s discuss your institutional or digital project',
    'caseStudies.cta.button': 'Start a conversation',

    // Studio Digital Page
    'studio.hero.title': 'Digital Studio',
    'studio.hero.tagline': 'Built for Africa. Built to last.',
    'studio.hero.subtitle': 'Modern digital solutions for African businesses: mobile apps, web platforms, dashboards',
    'studio.hero.cta': 'Start your project',

    'studio.services.title': 'Our Services',
    'studio.services.mobile.title': 'Mobile Applications',
    'studio.services.mobile.desc': 'Native iOS & Android apps with Flutter, designed to work offline',
    'studio.services.web.title': 'Web Platforms',
    'studio.services.web.desc': 'Modern websites and web applications with Next.js and React',
    'studio.services.dashboard.title': 'Dashboards',
    'studio.services.dashboard.desc': 'Management interfaces and real-time data visualization',
    'studio.services.api.title': 'APIs & Backend',
    'studio.services.api.desc': 'Robust backend architectures and RESTful/GraphQL APIs',

    'studio.process.title': 'Our Process',
    'studio.process.step1.title': 'Discovery',
    'studio.process.step1.desc': 'Understanding your business needs and goals',
    'studio.process.step2.title': 'Design',
    'studio.process.step2.desc': 'UX/UI prototypes and mockups',
    'studio.process.step3.title': 'Development',
    'studio.process.step3.desc': 'Quality code, testing, iterations',
    'studio.process.step4.title': 'Deployment',
    'studio.process.step4.desc': 'Production launch and training',
    'studio.process.step5.title': 'Support',
    'studio.process.step5.desc': 'Maintenance and evolution',

    'studio.offline.title': 'Offline-First Expertise',
    'studio.offline.subtitle': 'We understand connectivity challenges in Africa',
    'studio.offline.feature1.title': 'Smart Synchronization',
    'studio.offline.feature1.desc': 'Your data syncs automatically when connection returns',
    'studio.offline.feature2.title': 'Local Storage',
    'studio.offline.feature2.desc': 'All essential features available offline',
    'studio.offline.feature3.title': 'Network Optimization',
    'studio.offline.feature3.desc': 'Minimal data consumption, adapted to 2G/3G networks',

    'studio.tech.title': 'Technologies',
    'studio.tech.subtitle': 'Modern and proven stack',

    'studio.cta.title': 'Ready to launch your digital project?',
    'studio.cta.subtitle': 'Let\'s discuss your idea and turn it into reality',
    'studio.cta.button': 'Start now',

    // Team Page
    'team.hero.title': 'Our Team',
    'team.hero.subtitle': 'African experts serving digital transformation',

    'team.leadership.title': 'Leadership',
    'team.leadership.ceo.name': 'Papa Mamadou Diop',
    'team.leadership.ceo.role': 'Managing Director',
    'team.leadership.ceo.bio': '20+ years of experience in strategic consulting and complex project management. Expert in public governance and digital transformation in West Africa.',

    'team.values.title': 'What unites us',
    'team.values.expertise.title': 'African Expertise',
    'team.values.expertise.desc': 'Deep knowledge of African institutional and business contexts',
    'team.values.commitment.title': 'Commitment',
    'team.values.commitment.desc': 'End-to-end support with skills transfer',
    'team.values.excellence.title': 'Excellence',
    'team.values.excellence.desc': 'International standards adapted to local realities',

    'team.cta.title': 'Let\'s work together',
    'team.cta.button': 'Contact us',

    // Footer
    'footer.tagline': 'Your partner for digital transformation and sovereign governance in Africa',
    'footer.company.title': 'Company',
    'footer.company.about': 'About',
    'footer.company.team': 'Team',
    'footer.company.contact': 'Contact',
    'footer.services.title': 'Services',
    'footer.services.institutional': 'Institutional Consulting',
    'footer.services.studio': 'Digital Studio',
    'footer.services.expertises': 'Expertise',
    'footer.services.cases': 'Case Studies',
    'footer.contact.title': 'Contact',
    'footer.legal.title': 'Legal',
    'footer.copyright': '© 2025 Maalow Consulting Services. All rights reserved.',

    // Common
    'common.learnMore': 'Learn more',
    'common.viewAll': 'View all',
    'common.backHome': 'Back to home',
  }
};